export default {
  styleOverrides: {
    root: {
      fontSize: 14,
      minHeight: '50px',
    }
  },
}
